export default __webpack_public_path__ + "static/media/suitcase.f6aa7e76.svg";